var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dms-multi-select',{attrs:{"select-list":_vm.dropdownList.SmVariaList,"value":_vm.SmVariaList,"span":8,"label-key":"SM_VARIA_ZKT"},on:{"update:value":function($event){_vm.SmVariaList=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }